<template>
  <v-row>
    <v-col cols="12">
      <v-autocomplete
        :value="value.hostTypes"
        :label="$t('label.platform.hostType')"
        :items="autocompletion.hostTypes"
        multiple
        clearable
        hide-details
        @input="updateFilter('hostTypes', $event)"
      />
    </v-col>
    <v-col cols="12">
      <v-autocomplete
        :value="value.providers"
        :label="$t('label.platform.contentProviderName')"
        :items="autocompletion.contentProviders"
        multiple
        clearable
        hide-details
        @input="updateFilter('providers', $event)"
      />
    </v-col>
    <v-col cols="12">
      <v-autocomplete
        :value="value.releases"
        :label="$t('label.counter.releases')"
        :items="autocompletion.counterReleases"
        multiple
        clearable
        hide-details
        chips
        @input="updateFilter('releases', $event)"
      >
        <template #selection="{ item }">
          <v-chip :color="item === '5' ? '#cde9fa' : '#cbfcdc'" label>
            {{ item }}
          </v-chip>
        </template>
      </v-autocomplete>
    </v-col>
    <v-col cols="12">
      <v-autocomplete
        :value="value.reports"
        :label="$t('label.counter.reports')"
        :items="autocompletion.counterReports"
        multiple
        clearable
        hide-details
        chips
        @input="updateFilter('reports', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "PlatformFilters",

  props: {
    value: { required: true, type: Object },
    platforms: { type: Array, default: () => [] },
  },

  computed: {
    autocompletion() {
      const hostTypes = new Set();
      const contentProviders = new Set();
      const counterReleases = new Set();
      const counterReports = new Set();

      for (const item of this.platforms) {
        if (item.content_provider_name) {
          contentProviders.add(item.content_provider_name);
        }
        (item.host_types || []).forEach((type) => {
          if (type.name) {
            hostTypes.add(type.name);
          }
        });

        for (const [version, reports] of Object.entries(
          item.counterReports || {}
        )) {
          counterReleases.add(version);
          (reports || []).forEach((report) => counterReports.add(report));
        }
      }

      return {
        hostTypes: Array.from(hostTypes).sort(),
        contentProviders: Array.from(contentProviders).sort(),
        counterReleases: Array.from(counterReleases).sort(),
        counterReports: Array.from(counterReports).sort(),
      };
    },
  },

  methods: {
    updateFilter(key, value) {
      this.$emit("input", { ...this.value, [key]: value || [] });
    },
  },
};
</script>
